import React from 'react';

// Fullscreen JetKVM console. The KVM web UI is served through the dedicated
// nginx proxy on port 8443 (see nginx.conf), which strips X-Frame-Options so
// it can be embedded here.
const KVMView = ({ onClose, title = 'KVM Console' }) => {
    const kvmUrl = `https://${window.location.hostname}:8443/`;

    return (
        <div className='fixed inset-0 z-50 flex flex-col bg-black'>
            <div className='flex items-center justify-between h-10 px-4 bg-gray-900 text-white flex-shrink-0'>
                <span className='text-sm font-medium'>{title}</span>
                <button
                    onClick={onClose}
                    className='px-2 py-0.5 rounded hover:bg-gray-700 transition-colors'
                    title='Close KVM'
                >
                    ✕
                </button>
            </div>
            <iframe
                src={kvmUrl}
                title={title}
                className='flex-1 w-full border-0'
                allow='clipboard-read; clipboard-write; fullscreen'
                allowFullScreen
            />
        </div>
    );
};

export default KVMView;
